import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';

@Injectable()
export class ChangesService {
    depositAddedRx = new BehaviorSubject<number>(null);

    setDepositAdded(value: any) {
        this.depositAddedRx.next(value);
    }

    getDepositAddedQueue() {
        return this.depositAddedRx;
    }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/changes.service.ts